import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'all',
      component: () => import('./views/login.vue')
    },
    {
      path: '/userlist',
      name: 'user',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/userlist',
          name: 'userlist',
          component: () => import('./views/user/index.vue')
        }
      ]
    },
    {
      path: '/accoutlist',
      name: 'accout',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/accoutlist',
          name: 'accoutlist',
          component: () => import('./views/accout/index.vue')
        }
      ]
    },
    
    {
      path: '/companylist',
      name: 'company',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/companylist',
          name: 'companylist',
          component: () => import('./views/company/index.vue')
        },
        {
          path: '/companydetail',
          name: 'companydetail',
          component: () => import('./views/company/detail.vue')
        }
      ]
    },
    {
      path: '/contactlist',
      name: 'contact',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/contactlist',
          name: 'contactlist',
          component: () => import('./views/contact/index.vue')
        }
      ]
    },
    {
      path: '/goodslist',
      name: 'goods',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/goodslist',
          name: 'goodslist',
          component: () => import('./views/goods/index.vue')
        },
        {
          path: '/goodsdetail',
          name: 'goodsdetail',
          component: () => import('./views/goods/detail.vue')
        },
        {
          path: '/goodstype',
          name: 'goodstype',
          component: () => import('./views/goods/type.vue')
        }
      ]
    },
    {
      path: '/shiplist',
      name: 'ship',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/shiplist',
          name: 'shiplist',
          component: () => import('./views/ship/index.vue')
        }
      ]
    },
    {
      path: '/stocklist',
      name: 'stock',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/stocklist',
          name: 'stocklist',
          component: () => import('./views/stock/index.vue')
        },
        {
          path: '/kclist',
          name: 'kclist',
          component: () => import('./views/stock/list.vue')
        },
        {
          path: '/kcdetail',
          name: 'kcdetail',
          component: () => import('./views/stock/detail.vue')
        }
      ]
    },
    {
      path: '/orderlist',
      name: 'order',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/orderlist',
          name: 'orderlist',
          component: () => import('./views/order/sellorder.vue')
        },
        {
          path: '/buyorderlist',
          name: 'buyorderlist',
          component: () => import('./views/order/buyorder.vue')
        },
        {
          path: '/secondaryOrder',
          name: 'secondaryOrder',
          component: () => import('./views/order/secondaryOrder.vue')
        },
      ]
    },
    {
      path: '/replenishment',
      name: 'replenishment',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/replenishmentList',
          name: 'replenishmentList',
          component: () => import('./views/replenishment/index.vue')
        },
        {
          path: '/totallist',
          name: 'totallist',
          component: () => import('./views/replenishment/total.vue')
        },
        {
          path: '/noreplenishmentlist',
          name: 'noreplenishmentlist',
          component: () => import('./views/replenishment/noreplenishmentlist.vue')
        }
      ]
    },
    {
      path: '/ticketList',
      name: 'ticket',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/ticketList',
          name: 'ticketList',
          component: () => import('./views/ticket/index.vue')
        }
      ]
    },
    {
      path: '/monthList',
      name: 'month',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/monthList',
          name: 'monthList',
          component: () => import('./views/month/index.vue')
        },
        {
          path: '/monthinfo',
          name: 'monthinfo',
          component: () => import('./views/month/info.vue')
        },
        {
          path: '/monthrate',
          name: 'monthrate',
          component: () => import('./views/month/rate.vue')
        },
        {
          path: '/monthmoney',
          name: 'monthmoney',
          component: () => import('./views/month/money.vue')
        }
      ]
    },
    {
      path: '/rateList',
      name: 'rate',
      component: () => import('./views/home.vue'),
      children: [
        {
          path: '/rateList',
          name: 'rateList',
          component: () => import('./views/rate/index.vue')
        },
        {
          path: '/profit',
          name: 'profit',
          component: () => import('./views/rate/profit.vue')
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login.vue')
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('./views/test.vue')
    },
  ]
})
